export default {
  adding: "Adding",
  addNewChart: "add new chart",
  algorithm: "Algorithm",
  apply: "Apply",
  back: "Back",
  browse: "Browse",
  cancel: "cancel",
  checkingFile: "checking file",
  chooseFile: "Choose File",
  colors: "colors",
  completed: "Completed",
  completedAt: "Completed at",
  componentError: "Something went wrong!",
  created: "Created",
  createdAt: "Created at",
  delete: "Delete",
  deleteConfirmMessage: "Are you sure to delete?",
  deleting: "Deleting",
  details: "Details",
  done: "Completed",
  download: "Download",
  downloadFileProblem: "Sorry! There was a problem downloading the files.",
  dragToUpload: "drag & drop your picture or browse to upload",
  dragToUploadFile: "Drag & drop your file or browse to upload.",
  duplicate: "Duplicate",
  duration: "Duration",
  edit: "Edit",
  editInformation: "Edit information",
  error: "Error",
  errorDetails: "Error details",
  executedAt: "Executed at",
  failed: "Failed",
  failedReset: "Reset failed. Please try again later!",
  failedSave: "Save failed. Please try again later!",
  fileSelected: "File selected",
  form: {
    filledFieldsConstraint: "{{requiredFields}} must be filled!",
  },
  getDataProblem: "There was a problem getting data!",
  lastUpdate: "Last update:",
  loadingDataPleaseWait: "Loading data, please wait...",
  next: "Next",
  no: "No",
  noData: "No Data!",
  noRecords: "There are no records to show!",
  OK: "Okay",
  openInNewTab: "Open in a new tab",
  painting: "Painting",
  pending: "Pending",
  perM2: "Per m²",
  processing: "Processing",
  processingData: "Processing Data",
  progress: "Progress",
  queued: "Queued",
  refreshing: "Refreshing",
  resetAnyway: "Reset anyway",
  resetToDefault: "reset To Default",
  run: "Run",
  running: "Running",
  save: "save",
  saveAndExit: "Save & exit",
  select: "Select",
  server: "Server",
  skipped: "Skipped",
  sorry: "sorry",
  status: "Status",
  submit: "Submit",
  successfulFileUpload: "Your file has successfully been uploaded!",
  successfulImgaeUpload: "your image has successfully been uploaded!",
  successfulReset: "Reset successfully!",
  successfulSave: "Saved successfully!",
  summary: "Summary",
  unableToLoadApplicationDescription: "Data could not be loaded. Please refresh the page or contact support.",
  unableToLoadApplicationTitle: "Unable to load application",
  upload: "upload",
  uploadFile: "Upload file",
  uploadFiles: "upload files",
  uploadImage: "upload image",
  uploadingFile: "Uploading file",
  user: "User",
  waiting: "Waiting",
  yes: "Yes",
};
